export const hasPermission = (permissions, operation, object) => {
  if (!permissions || !object || !operation) {
    return false
  }

  const permission = permissions[object]

  if (!permission) {
    return false
  }

  return permission.indexOf(operation) !== -1
}

export const hasPermissionWithPermissions = permissions => (
  operation,
  object
) => hasPermission(permissions, operation, object)



// WEBPACK FOOTER //
// ../src/utils/hasPermission.js